/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export const EventUuid_TagMovement = "7aefa396-d97f-4cf6-ad9c-35c0c35d65a4";
export const EventUuid_TagEnteredLocation = "5d72e51a-605c-4ce5-829b-5e07a2adf2e9";
export const EventUuid_TagExitedLocation = "26c14665-8ac3-4748-a314-9067a01336e5";
export const EventUuid_TagEnteredZone = "5efe772e-3fa1-4685-acb9-a39e879419ec";
export const EventUuid_TagExitedZone = "e4c3d9aa-2beb-4297-bc77-11847d9435fd";
export const EventUuid_TagEnteredPerimeter = "298f6fc5-5fb9-4fc4-a7c7-0c8a1b4df953";
export const EventUuid_TagExitedPerimeter = "9681c59c-920b-4254-a70b-47899ea3e9ca";
	
// Asset Event UUIDs
export const EventUuid_AssetMovement = "767edf4d-3abc-4175-bfab-c451931313fa";
export const EventUuid_AssetEnteredLocation = "d569e13f-3784-44ce-9c95-c6108e20c91b";
export const EventUuid_AssetExitedLocation = "c1738f58-6b60-4446-99a0-d019ed4f22d5";
export const EventUuid_AssetEnteredZone = "6043229e-b9e0-4fbe-8ddf-60e218139f17";
export const EventUuid_AssetExitedZone = "a7729ca3-9163-441b-896f-3ebbd6d4d054";
export const EventUuid_AssetPerimeterEntered = "243b2674-96c8-4931-8743-390b1ed043e4";
export const EventUuid_AssetPerimeterExited = "71408dfb-0c04-48b0-a479-7a634cf80d54";
	
// Person Event UUIDs
export const EventUuid_PersonMovement = "bd4dd22c-eea8-4ada-8d57-76d5f4ada51a";
export const EventUuid_PersonEnteredLocation = "c459958f-919a-4afc-977e-45a5da4f46e4";
export const EventUuid_PersonExitedLocation = "c73e3777-675e-482d-b803-4c76f394d96a";
export const EventUuid_PersonEnteredZone = "afee68ce-8a14-4690-9225-a529c281e140";
export const EventUuid_PersonExitedZone = "afd1fc1a-a580-4933-8127-ebdd489f3c56";
export const EventUuid_PersonPerimeterEntered = "5cade3d1-b3e2-463b-b6fb-f729001893c5";
export const EventUuid_PersonPerimeterExited = "c4815c7b-764d-4651-85d5-18ddebf017d5";
